"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toc = exports.title = exports.slug = exports.pageId = exports.navTitle = exports.name = exports.metaDescription = exports.default = void 0;
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("@mdx-js/react");
/*@jsxRuntime automatic @jsxImportSource react*/
// translate-ignore

const pageId = exports.pageId = 142116065450;
const slug = exports.slug = 'guides/api/analytics-and-events/custom-events/custom-event-definitions';
// translate-ignore
const navTitle = exports.navTitle = 'Custom event definitions';
const title = exports.title = 'Define custom events';
const name = exports.name = 'Define custom events';
const metaDescription = exports.metaDescription = "Learn more about creating custom events using HubSpot's API.";
const toc = exports.toc = [{
  "depth": 0,
  "id": "create-an-event-definition",
  "label": "Create an event definition",
  "parent": null
}, {
  "depth": 0,
  "id": "event-properties",
  "label": "Event properties",
  "parent": null
}, {
  "depth": 1,
  "id": "hubspot-s-default-event-properties",
  "label": "HubSpot's default event properties",
  "parent": "event-properties"
}, {
  "depth": 1,
  "id": "define-new-properties",
  "label": "Define new properties",
  "parent": "event-properties"
}, {
  "depth": 1,
  "id": "update-existing-custom-properties",
  "label": "Update existing custom properties",
  "parent": "event-properties"
}, {
  "depth": 1,
  "id": "delete-a-property",
  "label": "Delete a property",
  "parent": "event-properties"
}, {
  "depth": 0,
  "id": "update-an-event",
  "label": "Update an event",
  "parent": null
}, {
  "depth": 0,
  "id": "delete-an-event",
  "label": "Delete an event",
  "parent": null
}, {
  "depth": 0,
  "id": "get-existing-event-definitions",
  "label": "Get existing event definitions",
  "parent": null
}];
function _createMdxContent(props) {
  const _components = Object.assign({
      h1: "h1",
      p: "p",
      a: "a",
      h2: "h2",
      code: "code",
      pre: "pre",
      table: "table",
      thead: "thead",
      tr: "tr",
      th: "th",
      tbody: "tbody",
      td: "td",
      ul: "ul",
      li: "li",
      h3: "h3",
      ol: "ol",
      em: "em"
    }, (0, _react.useMDXComponents)(), props.components),
    {
      RelatedApiLink,
      ProductTier,
      Alert
    } = _components;
  if (!Alert) _missingMdxReference("Alert", true);
  if (!ProductTier) _missingMdxReference("ProductTier", true);
  if (!RelatedApiLink) _missingMdxReference("RelatedApiLink", true);
  return (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [(0, _jsxRuntime.jsx)(_components.h1, {
      children: "Define custom events"
    }), "\n", (0, _jsxRuntime.jsx)(RelatedApiLink, {}), "\n", (0, _jsxRuntime.jsx)(ProductTier, {
      tiers: ['marketing_hub-enterprise', 'sales_hub-enterprise', 'cms-enterprise', 'service_hub-enterprise', 'operations_hub-enterprise']
    }), "\n", (0, _jsxRuntime.jsx)(_components.p, {
      children: "Custom events enable you to define and track events that are unique to your business, such as events on your site or in an app. You can configure events to store information within properties, which you can then use across HubSpot's tools."
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["To send ", (0, _jsxRuntime.jsx)(_components.a, {
        href: "/guides/api/analytics-and-events/custom-events/custom-event-completions",
        children: "custom event"
      }), " data to HubSpot, you first need to define the event. This is similar to custom CRM objects, where you first need to define the custom object before you can create individual records for that object. An event definition includes details such as its metadata, CRM object associations, and properties."]
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["Below, learn more about creating and managing event definitions using the API. To learn how to create event definitions without using the API, check out ", (0, _jsxRuntime.jsx)(_components.a, {
        href: "https://knowledge.hubspot.com/reports/create-custom-behavioral-events-with-the-code-wizard",
        children: "HubSpot's Knowledge Base"
      }), "."]
    }), "\n", (0, _jsxRuntime.jsx)(_components.h2, {
      children: "Create an event definition"
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["To create the custom event schema, make a ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "POST"
      }), " request to ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "events/v3/event-definitions"
      }), ". In the request body, include definitions for your event schema, including its label, name, CRM object associations, and custom properties."]
    }), "\n", (0, _jsxRuntime.jsx)(_components.p, {
      children: "The request body below provides a basic example of an event definition:"
    }), "\n", (0, _jsxRuntime.jsx)(_components.pre, {
      children: (0, _jsxRuntime.jsx)(_components.code, {
        className: "language-json",
        children: "{\n  \"label\": \"My event label\",\n  \"name\": \"unique_event_name\",\n  \"description\": \"An event description that helps users understand what the event tracks.\",\n  \"primaryObject\": \"COMPANY\",\n  \"propertyDefinitions\": [\n    {\n      \"name\": \"choice-property\",\n      \"label\": \"Choice property\",\n      \"type\": \"enumeration\",\n      \"options\": [\n        {\n          \"label\": \"Option 1\",\n          \"value\": \"1\"\n        },\n        {\n          \"label\": \"Option 2\",\n          \"value\": \"2\"\n        }\n      ]\n    },\n    {\n      \"name\": \"string-property\",\n      \"label\": \"String property\",\n      \"type\": \"string\"\n    }\n  ],\n  \"includeDefaultProperties\": true\n}\n"
      })
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["If you want to automatically link event completions to records of a specified CRM object type, you can include a ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "customMatchingId"
      }), " in your ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "POST"
      }), " request. Within this field, define a ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "primaryObjectRule"
      }), " object with two fields: the unique object property that you've set up beforehand as the ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "targetObjectPropertyName"
      }), ", and one of the properties you defined in the ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "propertyDefinitions"
      }), " from your event definition."]
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["For example, the following request body specifies a ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "customMatchingId"
      }), " that matches on a CRM object property name of ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "\"unique_object_property\""
      }), " and the event property name of ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "\"string_property\""
      }), ":"]
    }), "\n", (0, _jsxRuntime.jsx)(_components.pre, {
      children: (0, _jsxRuntime.jsx)(_components.code, {
        className: "language-json",
        children: "{\n  \"label\": \"My event label\",\n  \"name\": \"unique_event_name\",\n  \"description\": \"An event description that helps users understand what the event tracks.\",\n  \"primaryObject\": \"COMPANY\",\n  \"propertyDefinitions\": [\n    {\n      \"name\": \"string-property\",\n      \"label\": \"String property\",\n      \"type\": \"string\"\n    }\n  ],\n  \"customMatchingId\": {\n    \"primaryObjectRule\": {\n      \"targetObjectPropertyName\": \"unique_object_property\",\n      \"eventPropertyName\": \"event_property\"\n    }\n  }\n}\n"
      })
    }), "\n", (0, _jsxRuntime.jsx)(_components.p, {
      children: "A full list of available parameters for the request body are detailed in the table below:"
    }), "\n", (0, _jsxRuntime.jsxs)(_components.table, {
      children: [(0, _jsxRuntime.jsx)(_components.thead, {
        children: (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.th, {
            children: "Parameter"
          }), (0, _jsxRuntime.jsx)(_components.th, {
            children: "Type"
          }), (0, _jsxRuntime.jsx)(_components.th, {
            children: "Description"
          })]
        })
      }), (0, _jsxRuntime.jsxs)(_components.tbody, {
        children: [(0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "label"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "String"
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "The event's human readable label, which will display in HubSpot (up to 100 characters). Long labels may be cut off in certain parts of HubSpot's UI."
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "name"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "String"
          }), (0, _jsxRuntime.jsxs)(_components.td, {
            children: ["The unique, internal name of the event, which you'll use to reference the event through the API. If no value is provided, HubSpot will automatically generate one based on the label.", (0, _jsxRuntime.jsxs)("ul", {
              children: [(0, _jsxRuntime.jsx)("li", {
                children: "This property cannot be changed after the event definition is created."
              }), (0, _jsxRuntime.jsx)("li", {
                children: "This property can only contain lowercase letters, numbers, underscores, and hyphens (up to 50 characters)."
              }), (0, _jsxRuntime.jsx)("li", {
                children: "The first character must be a letter."
              })]
            })]
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "description"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "String"
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "The event's description, which will display in HubSpot."
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "primaryObject"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "String"
          }), (0, _jsxRuntime.jsxs)(_components.td, {
            children: ["The type of CRM object that event data will be associated with. Event completions will appear on the CRM records of that object type. Can be one of: ", (0, _jsxRuntime.jsx)(_components.code, {
              children: "\"CONTACT\""
            }), " (default), ", (0, _jsxRuntime.jsx)(_components.code, {
              children: "\"COMPANY\""
            }), ", ", (0, _jsxRuntime.jsx)(_components.code, {
              children: "\"DEAL\""
            }), ", ", (0, _jsxRuntime.jsx)(_components.code, {
              children: "\"TICKET\""
            }), ", ", (0, _jsxRuntime.jsx)(_components.code, {
              children: "\"<CUSTOM_OBJECT_NAME>\""
            }), ". This cannot be changed after the event definition is created."]
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "propertyDefinitions"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Array"
          }), (0, _jsxRuntime.jsxs)(_components.td, {
            children: ["In addition to the ", (0, _jsxRuntime.jsx)(_components.a, {
              href: "#hubspot-s-default-event-properties",
              children: "HubSpot default event properties"
            }), ", you can include this array to define custom event properties (up to 50). For each property object, include the following fields:", (0, _jsxRuntime.jsxs)("ul", {
              children: [(0, _jsxRuntime.jsxs)("li", {
                children: [(0, _jsxRuntime.jsx)(_components.code, {
                  children: "name"
                }), ": the property's internal name, which you'll use when sending event data through the API."]
              }), (0, _jsxRuntime.jsxs)("li", {
                children: [(0, _jsxRuntime.jsx)(_components.code, {
                  children: "label"
                }), ": the property's in-app label."]
              }), (0, _jsxRuntime.jsxs)("li", {
                children: [(0, _jsxRuntime.jsx)(_components.code, {
                  children: "type"
                }), ": the ", (0, _jsxRuntime.jsx)(_components.a, {
                  href: "#event-properties",
                  children: "type of property"
                }), ". Default is ", (0, _jsxRuntime.jsx)(_components.code, {
                  children: "string"
                }), "."]
              }), (0, _jsxRuntime.jsxs)("li", {
                children: [(0, _jsxRuntime.jsx)(_components.code, {
                  children: "options"
                }), ": for ", (0, _jsxRuntime.jsx)(_components.code, {
                  children: "enumeration"
                }), " type properties, this array defines the available values. Must include both a ", (0, _jsxRuntime.jsx)(_components.code, {
                  children: "label"
                }), " and ", (0, _jsxRuntime.jsx)(_components.code, {
                  children: "value"
                }), " for each option."]
              }), (0, _jsxRuntime.jsxs)("li", {
                children: [(0, _jsxRuntime.jsx)(_components.code, {
                  children: "description"
                }), ": text that describes the property."]
              })]
            })]
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "customMatchingId"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Object"
          }), (0, _jsxRuntime.jsxs)(_components.td, {
            children: ["As an alternative to including the target object's ", (0, _jsxRuntime.jsx)(_components.code, {
              children: "objectId"
            }), " in the event completion data, this optional field defines a rule to automatically link event completions to records of the specified CRM object type. This is done by matching the value of a property in the event data with the value of a ", (0, _jsxRuntime.jsx)("u", {
              children: "unique"
            }), " property on the target object. This object must include a nested ", (0, _jsxRuntime.jsx)(_components.code, {
              children: "primaryObjectRule"
            }), " object, which in turn must include two fields: ", (0, _jsxRuntime.jsxs)("ul", {
              children: [(0, _jsxRuntime.jsxs)("li", {
                children: [(0, _jsxRuntime.jsx)(_components.code, {
                  children: "targetObjectPropertyName"
                }), ": a string that specifies the name of the unique property on the target CRM object to use for matching."]
              }), (0, _jsxRuntime.jsxs)("li", {
                children: [(0, _jsxRuntime.jsx)(_components.code, {
                  children: "eventPropertyName"
                }), ": a string that specifies the name of the property in the custom event data to use for matching."]
              })]
            })]
          })]
        }), (0, _jsxRuntime.jsxs)(_components.tr, {
          children: [(0, _jsxRuntime.jsx)(_components.td, {
            children: (0, _jsxRuntime.jsx)(_components.code, {
              children: "includeDefaultProperties"
            })
          }), (0, _jsxRuntime.jsx)(_components.td, {
            children: "Boolean"
          }), (0, _jsxRuntime.jsxs)(_components.td, {
            children: ["An optional field that specifies whether the event should include the set of ", (0, _jsxRuntime.jsx)(_components.a, {
              href: "#hubspot-s-default-event-properties",
              children: "default event properties"
            }), ". If no value is provided, this field will automatically be set to ", (0, _jsxRuntime.jsx)(_components.code, {
              children: "true"
            }), "."]
          })]
        })]
      })]
    }), "\n", (0, _jsxRuntime.jsx)(_components.h2, {
      children: "Event properties"
    }), "\n", (0, _jsxRuntime.jsx)(_components.p, {
      children: "Custom event properties are used to store information on individual custom event completions. These properties should be used when appropriate for sending event completions, but they are not required for an event completion to be valid. For each event definition, HubSpot provides a default set of 32 properties. In addition, You can create up to 50 custom properties per event definition."
    }), "\n", (0, _jsxRuntime.jsx)(_components.p, {
      children: "Properties can be of the following types:"
    }), "\n", (0, _jsxRuntime.jsxs)(_components.ul, {
      children: ["\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: [(0, _jsxRuntime.jsx)(_components.code, {
          children: "bool"
        }), ": a property that receives a boolean value. Values must be represented as ", (0, _jsxRuntime.jsx)(_components.code, {
          children: "true"
        }), " or ", (0, _jsxRuntime.jsx)(_components.code, {
          children: "false"
        }), "."]
      }), "\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: [(0, _jsxRuntime.jsx)(_components.code, {
          children: "date"
        }), ": a property that receives a date representing a specific day, month, and year. Values must be represented in UTC time and can be formatted as ", (0, _jsxRuntime.jsx)(_components.a, {
          href: "/guides/api/crm/properties#add-values-to-date-and-datetime-properties",
          children: "ISO 8601 strings"
        }), " or EPOCH-timestamps in milliseconds (i.e. midnight UTC)."]
      }), "\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: [(0, _jsxRuntime.jsx)(_components.code, {
          children: "datetime"
        }), ": A property that receives epoch millisecond or ISO8601 values representing a timestamp."]
      }), "\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: [(0, _jsxRuntime.jsx)(_components.code, {
          children: "enumeration"
        }), ": A property with predefined options. When creating this property type, include an ", (0, _jsxRuntime.jsx)(_components.code, {
          children: "options"
        }), " array to set the available values."]
      }), "\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: [(0, _jsxRuntime.jsx)(_components.code, {
          children: "number"
        }), ": a property that receives numeric values with up to one decimal."]
      }), "\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: [(0, _jsxRuntime.jsx)(_components.code, {
          children: "string"
        }), ": a property that receives plain text strings. If the property name contains the words ", (0, _jsxRuntime.jsx)(_components.code, {
          children: "url"
        }), ", ", (0, _jsxRuntime.jsx)(_components.code, {
          children: "referrer"
        }), ", or ", (0, _jsxRuntime.jsx)(_components.code, {
          children: "link"
        }), ", the property value can be up to 1024 characters. Otherwise, property values can be up to 256 characters."]
      }), "\n"]
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["Below, learn about HubSpot's default event properties, how to ", (0, _jsxRuntime.jsx)(_components.a, {
        href: "#define-new-properties",
        children: "define new properties for existing events"
      }), ", and how to ", (0, _jsxRuntime.jsx)(_components.a, {
        href: "#update-existing-custom-properties",
        children: "update existing custom event properties"
      }), "."]
    }), "\n", (0, _jsxRuntime.jsx)(_components.h3, {
      children: "HubSpot's default event properties"
    }), "\n", (0, _jsxRuntime.jsxs)(_components.ul, {
      children: ["\n", (0, _jsxRuntime.jsx)(_components.li, {
        children: (0, _jsxRuntime.jsx)(_components.code, {
          children: "hs_asset_description"
        })
      }), "\n", (0, _jsxRuntime.jsx)(_components.li, {
        children: (0, _jsxRuntime.jsx)(_components.code, {
          children: "hs_asset_type"
        })
      }), "\n", (0, _jsxRuntime.jsx)(_components.li, {
        children: (0, _jsxRuntime.jsx)(_components.code, {
          children: "hs_browser"
        })
      }), "\n", (0, _jsxRuntime.jsx)(_components.li, {
        children: (0, _jsxRuntime.jsx)(_components.code, {
          children: "hs_campaign_id"
        })
      }), "\n", (0, _jsxRuntime.jsx)(_components.li, {
        children: (0, _jsxRuntime.jsx)(_components.code, {
          children: "hs_city"
        })
      }), "\n", (0, _jsxRuntime.jsx)(_components.li, {
        children: (0, _jsxRuntime.jsx)(_components.code, {
          children: "hs_country"
        })
      }), "\n", (0, _jsxRuntime.jsx)(_components.li, {
        children: (0, _jsxRuntime.jsx)(_components.code, {
          children: "hs_device_name"
        })
      }), "\n", (0, _jsxRuntime.jsx)(_components.li, {
        children: (0, _jsxRuntime.jsx)(_components.code, {
          children: "hs_device_type"
        })
      }), "\n", (0, _jsxRuntime.jsx)(_components.li, {
        children: (0, _jsxRuntime.jsx)(_components.code, {
          children: "hs_element_class"
        })
      }), "\n", (0, _jsxRuntime.jsx)(_components.li, {
        children: (0, _jsxRuntime.jsx)(_components.code, {
          children: "hs_element_id"
        })
      }), "\n", (0, _jsxRuntime.jsx)(_components.li, {
        children: (0, _jsxRuntime.jsx)(_components.code, {
          children: "hs_element_text"
        })
      }), "\n", (0, _jsxRuntime.jsx)(_components.li, {
        children: (0, _jsxRuntime.jsx)(_components.code, {
          children: "hs_language"
        })
      }), "\n", (0, _jsxRuntime.jsx)(_components.li, {
        children: (0, _jsxRuntime.jsx)(_components.code, {
          children: "hs_link_href"
        })
      }), "\n", (0, _jsxRuntime.jsx)(_components.li, {
        children: (0, _jsxRuntime.jsx)(_components.code, {
          children: "hs_operating_system"
        })
      }), "\n", (0, _jsxRuntime.jsx)(_components.li, {
        children: (0, _jsxRuntime.jsx)(_components.code, {
          children: "hs_operating_version"
        })
      }), "\n", (0, _jsxRuntime.jsx)(_components.li, {
        children: (0, _jsxRuntime.jsx)(_components.code, {
          children: "hs_page_content_type"
        })
      }), "\n", (0, _jsxRuntime.jsx)(_components.li, {
        children: (0, _jsxRuntime.jsx)(_components.code, {
          children: "hs_page_id"
        })
      }), "\n", (0, _jsxRuntime.jsx)(_components.li, {
        children: (0, _jsxRuntime.jsx)(_components.code, {
          children: "hs_page_title"
        })
      }), "\n", (0, _jsxRuntime.jsx)(_components.li, {
        children: (0, _jsxRuntime.jsx)(_components.code, {
          children: "hs_page_url"
        })
      }), "\n", (0, _jsxRuntime.jsx)(_components.li, {
        children: (0, _jsxRuntime.jsx)(_components.code, {
          children: "hs_parent_module_id"
        })
      }), "\n", (0, _jsxRuntime.jsx)(_components.li, {
        children: (0, _jsxRuntime.jsx)(_components.code, {
          children: "hs_referrer"
        })
      }), "\n", (0, _jsxRuntime.jsx)(_components.li, {
        children: (0, _jsxRuntime.jsx)(_components.code, {
          children: "hs_region"
        })
      }), "\n", (0, _jsxRuntime.jsx)(_components.li, {
        children: (0, _jsxRuntime.jsx)(_components.code, {
          children: "hs_screen_height"
        })
      }), "\n", (0, _jsxRuntime.jsx)(_components.li, {
        children: (0, _jsxRuntime.jsx)(_components.code, {
          children: "hs_screen_width"
        })
      }), "\n", (0, _jsxRuntime.jsx)(_components.li, {
        children: (0, _jsxRuntime.jsx)(_components.code, {
          children: "hs_touchpoint_source"
        })
      }), "\n", (0, _jsxRuntime.jsx)(_components.li, {
        children: (0, _jsxRuntime.jsx)(_components.code, {
          children: "hs_tracking_name"
        })
      }), "\n", (0, _jsxRuntime.jsx)(_components.li, {
        children: (0, _jsxRuntime.jsx)(_components.code, {
          children: "hs_user_agent"
        })
      }), "\n", (0, _jsxRuntime.jsx)(_components.li, {
        children: (0, _jsxRuntime.jsx)(_components.code, {
          children: "hs_utm_campaign"
        })
      }), "\n", (0, _jsxRuntime.jsx)(_components.li, {
        children: (0, _jsxRuntime.jsx)(_components.code, {
          children: "hs_utm_content"
        })
      }), "\n", (0, _jsxRuntime.jsx)(_components.li, {
        children: (0, _jsxRuntime.jsx)(_components.code, {
          children: "hs_utm_medium"
        })
      }), "\n", (0, _jsxRuntime.jsx)(_components.li, {
        children: (0, _jsxRuntime.jsx)(_components.code, {
          children: "hs_utm_source"
        })
      }), "\n", (0, _jsxRuntime.jsx)(_components.li, {
        children: (0, _jsxRuntime.jsx)(_components.code, {
          children: "hs_utm_term"
        })
      }), "\n"]
    }), "\n", (0, _jsxRuntime.jsx)(_components.h3, {
      children: "Define new properties"
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["To define a new property on an existing custom event, make a ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "POST"
      }), " request to ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "events/v3/event-definitions/{eventName}/property"
      }), ". In the request body, include the definition for your property."]
    }), "\n", (0, _jsxRuntime.jsx)(_components.pre, {
      children: (0, _jsxRuntime.jsx)(_components.code, {
        className: "language-json",
        children: "{\n  \"name\": \"property-name\",\n  \"label\": \"Property name\",\n  \"type\": \"enumeration\",\n  \"options\": [\n    {\n      \"label\": \"label\",\n      \"value\": \"value\"\n    }\n  ]\n}\n"
      })
    }), "\n", (0, _jsxRuntime.jsx)(_components.p, {
      children: "When naming your property, keep the following in mind:"
    }), "\n", (0, _jsxRuntime.jsxs)(_components.ul, {
      children: ["\n", (0, _jsxRuntime.jsx)(_components.li, {
        children: "Once you create a property, the property’s name cannot be changed."
      }), "\n", (0, _jsxRuntime.jsx)(_components.li, {
        children: "The name can only contain lowercase letters, numbers, underscores, and hyphens."
      }), "\n", (0, _jsxRuntime.jsx)(_components.li, {
        children: "The first character of the property name must be a letter."
      }), "\n", (0, _jsxRuntime.jsx)(_components.li, {
        children: "The property name and label can each be up to 50 characters long."
      }), "\n", (0, _jsxRuntime.jsx)(_components.li, {
        children: "If an property name is not provided, one will be auto-generated using the property label."
      }), "\n", (0, _jsxRuntime.jsx)(_components.li, {
        children: "Long labels may be cut off in certain parts of the HubSpot UI."
      }), "\n"]
    }), "\n", (0, _jsxRuntime.jsx)(_components.h3, {
      children: "Update existing custom properties"
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["To update an existing property on a custom event, make a ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "PATCH"
      }), " request to ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "events/v3/event-definitions/{eventName}/property"
      }), ". The only fields that can be updated on a property are the ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "label"
      }), ", ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "description"
      }), ", and ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "options"
      }), " for enumeration properties."]
    }), "\n", (0, _jsxRuntime.jsx)(Alert, {
      type: "warning",
      titleText: "Please note:",
      children: (0, _jsxRuntime.jsxs)(_components.p, {
        children: ["To change the type of property, use the ", (0, _jsxRuntime.jsx)(_components.code, {
          children: "DELETE"
        }), " endpoint to delete the property and recreate it with the correct type."]
      })
    }), "\n", (0, _jsxRuntime.jsx)(_components.h3, {
      children: "Delete a property"
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["To delete an existing property on a custom event, make a ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "DELETE"
      }), " request to ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "events/v3/event-definitions/{eventName}/property/{propertyName}"
      }), "."]
    }), "\n", (0, _jsxRuntime.jsx)(_components.p, {
      children: "When a property is deleted, it will no longer be available for use in future event completions. Past completions will still have the property values."
    }), "\n", (0, _jsxRuntime.jsx)(_components.h2, {
      children: "Update an event"
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["To update an existing custom event schema, make a ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "PATCH"
      }), " request to ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "events/v3/event-definitions/{eventName}"
      }), "."]
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["The only event definition fields that can be updated are ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "label"
      }), " and ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "description"
      }), "."]
    }), "\n", (0, _jsxRuntime.jsx)(_components.pre, {
      children: (0, _jsxRuntime.jsx)(_components.code, {
        className: "language-json",
        children: "{\n  \"label\": \"Event label\",\n  \"description\": \"A description of the event\"\n}\n"
      })
    }), "\n", (0, _jsxRuntime.jsx)(_components.h2, {
      children: "Delete an event"
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["To delete a custom event, make a ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "DELETE"
      }), " request to ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "events/v3/event-definitions/{eventName}"
      }), "."]
    }), "\n", (0, _jsxRuntime.jsx)(_components.p, {
      children: "Deleting a custom event will remove it from any other HubSpot tools that are referencing it, such as workflows and reports."
    }), "\n", (0, _jsxRuntime.jsx)(Alert, {
      type: "warning",
      titleText: "Please note when deleting an event:",
      children: (0, _jsxRuntime.jsxs)(_components.ol, {
        children: ["\n", (0, _jsxRuntime.jsx)(_components.li, {
          children: "All of the events for that event definition will be deleted and unrecoverable."
        }), "\n", (0, _jsxRuntime.jsxs)(_components.li, {
          children: ["Previously deleted ", (0, _jsxRuntime.jsx)(_components.code, {
            children: "eventName"
          }), "'s ", (0, _jsxRuntime.jsx)("u", {
            children: "cannot"
          }), " be used again, so exercise caution when deleting an event."]
        }), "\n"]
      })
    }), "\n", (0, _jsxRuntime.jsx)(_components.h2, {
      children: "Get existing event definitions"
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["To fetch a single event definition, make a ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "GET"
      }), " request to ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "events/v3/event-definitions/{eventName}"
      }), "."]
    }), "\n", (0, _jsxRuntime.jsxs)(_components.p, {
      children: ["To search event definitions by specific criteria, make a ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "GET"
      }), " request to ", (0, _jsxRuntime.jsx)(_components.code, {
        children: "events/v3/event-definitions"
      }), ". You can supply the following query parameters to refine your search:"]
    }), "\n", (0, _jsxRuntime.jsxs)(_components.ul, {
      children: ["\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: [(0, _jsxRuntime.jsx)(_components.code, {
          children: "searchString"
        }), ": searches for events that contain the specified characters in the ", (0, _jsxRuntime.jsx)(_components.code, {
          children: "name"
        }), " field. Searching is ", (0, _jsxRuntime.jsx)("u", {
          children: "not"
        }), " fuzzy, but is instead a naive ", (0, _jsxRuntime.jsx)(_components.em, {
          children: "contains"
        }), " search."]
      }), "\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: [(0, _jsxRuntime.jsx)(_components.code, {
          children: "after"
        }), ": a hashed string provided in paged responses for viewing the next page of search results."]
      }), "\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: [(0, _jsxRuntime.jsx)(_components.code, {
          children: "limit"
        }), ": the maximum number of results to return."]
      }), "\n", (0, _jsxRuntime.jsxs)(_components.li, {
        children: [(0, _jsxRuntime.jsx)(_components.code, {
          children: "includeProperties"
        }), ": a boolean value that specifies whether to include event properties in the returned results."]
      }), "\n"]
    })]
  });
}
function MDXContent(props = {}) {
  const {
    wrapper: MDXLayout
  } = Object.assign({}, (0, _react.useMDXComponents)(), props.components);
  return MDXLayout ? (0, _jsxRuntime.jsx)(MDXLayout, Object.assign({}, props, {
    children: (0, _jsxRuntime.jsx)(_createMdxContent, props)
  })) : _createMdxContent(props);
}
var _default = exports.default = MDXContent;
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}